<template>
	<div class="viprefundinfo">
		<publicHeader :pageTitle="pageTitle" isWhite="true" :urlhandle='urlhandle'></publicHeader>
		<div class="zhanwei"></div>
		<div class="viprefundinfo_1">
			<div class="refundInfo">
				<div class="refundStatus">
					<img src="https://images.zhibo.tv/2022/0328/toApplyForing.png" v-if="refundInfo.status == 1">
					<img src="https://images.zhibo.tv/2022/0328/refundSuccess.png" v-else-if="refundInfo.status == 2">
					<img src="https://images.zhibo.tv/2022/0328/refundRefused.png" v-else-if="refundInfo.status == 3">
					<div class="applyFor status" v-if="refundInfo.status == 1">申请中...</div>
					<div class="success status" v-else-if="refundInfo.status == 2">退款成功！</div>
					<div class="failure status" v-else-if="refundInfo.status == 3">已拒绝</div>
				</div>
				<div class="refused" v-if="refundInfo.status == 3">{{refundInfo.reason}}</div>
				<div class="typeItem typeItem0">
					<div class="refundName nameItem">会员名称</div>
					<div class="refundNameVal valItem">{{refundInfo.vipName}}会员</div>
				</div>
				<div class="typeItem">
					<div class="delineTime nameItem">到期时间</div>
					<div class="delineTimeVal valItem">{{refundInfo.expireDate}}</div>
				</div>
				<div class="typeItem">
					<div class="remainTime nameItem">剩余时长（天）</div>
					<div class="remainTimeVal valItem" v-if="refundInfo.remainingTime <= 0 || refundInfo.remainingTime == ''">0</div>
					<div class="remainTimeVal valItem" v-else>{{refundInfo.remainingTime}}</div>
				</div>
				<div class="typeItem">
					<div class="forecastPrice nameItem">退款预估金额（元）</div>
					<div class="forecastPriceVal"><span class="icon_price">¥</span>{{refundInfo.expectAmount}}</div>
				</div>
			</div>
		</div>

		<div class="continueToApply" v-if="refundInfo.status == 2 || refundInfo.status == 3">
			<div @click="gotoRefund">继续申请退费</div>
		</div>
	</div>
</template>

<script>
	import publicHeader from '../components/PublicHeader'

	export default {
		name: 'viprefundinfo',
		components: {
			publicHeader
		},
		data() {
			return {
				token: '',
				id: '',
				vipId: '',
				refundInfo: {},
				urlhandle:'',
				pageTitle:''
			}
		},
		created() {
			this.pageTitle = '退费详情'
			this.getToken()
			this.getRefundItemInfo()
		},
		beforeRouteEnter(to, from, next) {
			console.log(to.name, from.name)
			if((to.name == 'vipRefundInfo' && from.name == 'vipFefund') || (to.name == 'vipRefundInfo' && from.name == 'refundHistory')){
				next((vm) => {
					console.log(vm)
					vm.urlhandle = 'back'
				})
			}
			next()
		},
		methods: {
			// 获取退费详情
			getRefundItemInfo() {
				const params = {
					token: this.token,
					refundId: this.id,
					vipId:this.vipId
				}
				this.$vipapi.getRefundItemInfo(params).then(res => {
					console.log('退款详情信息', res)
					if (res.data.data) {
						this.refundInfo = res.data.data
					}
				})
			},
			gotoRefund() {
				this.$router.push(`/viprefund?token=${this.token}&vipId=${this.vipId}`)
			},
			// 获取url上的信息
			getcommit(name) {
				return (
					decodeURIComponent(
						(new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(
							location.href
						) || ['', ''])[1].replace(/\+/g, '%20')
					) || false
				)
			},
			// 获取token
			getToken() {
				if (this.$CONFIG.isVerify && this.isIOS) {
					this.token = '2a9cc326033c71cd67ac7caba01c2cd0*8028670'
				} else {
					this.token = this.getcommit('token') || ''
				}
				this.id = this.getcommit('id') || ''
				this.vipId = this.getcommit('vipId') || ''
			},
		}
	}
</script>

<style lang="less" scoped="scoped">
	.viprefundinfo {
		.viprefundinfo_1{
			padding: 0 .2rem;
		}

		.refundInfo {
			margin: .2rem 0 0 0;
			background: #F9FAFC;
			border-radius: .1rem;
			padding: .4rem .4rem .3rem;

			.refundStatus {
				display: flex;
				align-items: center;

				img {
					width: .4rem;
					height: .4rem;
					display: block;
					margin-right: .1rem;
				}

				.status {
					font-size: .32rem;
					font-family: PingFangSC-Semibold, PingFang SC;
					font-weight: 600;
				}

				.applyFor {
					color: #C4A485;
				}

				.success {
					color: #FF4A4A;
				}

				.failure {
					color: #222222;
				}
			}

			.refused {
				margin-top: .1rem;
				font-size: .24rem;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #222222;
				line-height: .33rem;
			}

			.typeItem0 {
				margin-top: .3rem;
			}

			.typeItem {
				display: flex;
				align-items: center;
				justify-content: space-between;

				.refundName {}

				.nameItem {
					font-size: .28rem;
					font-family: PingFangSC-Regular, PingFang SC;
					font-weight: 400;
					color: #999999;
					padding: .2rem 0;
				}

				.valItem {
					font-size: .28rem;
					font-family: PingFangSC-Regular, PingFang SC;
					font-weight: 400;
					color: #222222;
				}

				.forecastPriceVal {
					font-size: .4rem;
					font-family: BebasNeue;
					color: #222222;
					line-height: .4rem;

					.icon_price {
						font-size: .3rem;
						font-family: BebasNeue;
						color: #222222;
						margin-right: .04rem;
					}
				}
			}
		}

		.continueToApply {
			width: 100%;
			background: #ffffff;
			position: fixed;
			bottom: 0;
			padding: 0 .4rem;
			box-sizing: border-box;
			// padding-bottom: constant(safe-area-inset-bottom);
			// padding-bottom: env(safe-area-inset-bottom);

			div {
				height: .96rem;
				margin: .2rem 0;
				font-size: .32rem;
				color: #613F25;
				font-family: PingFangSC-Medium, PingFang SC;
				font-weight: 500;
				background: linear-gradient(145deg, #F5E4D3 0%, #C4A485 100%);
				border-radius: .48rem;
				display: flex;
				align-items: center;
				justify-content: center;
			}
		}
	}
</style>
